module.exports = __webpack_public_path__ + "img/primary_2x2_z16.92f6a6c8.svg";